import { MenuItem } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(() => ({
  padding: "1rem 2rem",
  minHeight: "calc(100vh - 230px)",

  "@media screen and (max-width: 435px)": {
    padding: "1rem",
  },
}))

export const HeaderRightText = styled("span")(() => ({
  font: "700 12px/16px Manrope",
  color: "#465869"
}));

export const TextAreaWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  "& span": {
    color: "#308CDB",
    font: "600 14px/24px Manrope",
    marginBottom: 10,
  },
  "& textarea": {
    width: "56vw",
    height: "10vh",
    border: "1px solid #E4E7EC",
    borderRadius: 8,
    padding: "12px 16px",
    resize: "none",
    color: "#667085",
    fontFamily: "Manrope",
    "&::placeholder": {
      color: "#D0D5DD",
      font: "500 14px/24px Manrope",
    },
    "@media screen and (max-width: 435px)": {
      width: "75vw",
    },
  },
}))

export const PageWrapper = styled("div")(() => ({
  backgroundColor: "#FFF",
}))

interface ActionMenuItemProp {
  type: 'approve' | 'decline' | 'sendToReview';
}
const getMenuItemColor = (type: 'approve' | 'decline' | 'sendToReview') => {
  switch(type){
    case 'approve':
      return '#32D583'
    case 'decline':
      return '#F97066'
    default: return '#667085'
  }
}

export const ActionMenuItem = styled(MenuItem)(({ type }: ActionMenuItemProp) => ({
  color: getMenuItemColor(type),
  font: "500 12px/24px Manrope !important",
}));

const status = makeStyles(() => ({
  uiTab: {
    height: "100% !important",
  },
  tabDetails: {
    padding: "1.5rem",
    "@media screen and (max-width: 435px)": {
      padding: "0.75rem !important",
    },
  },
  mt40: {
    marginTop: 40,
  },
  wrapperTemplate: {
    padding: "12px 16px",
    height:  "calc(100vh - 168px)",
    "& span": {
      font: "500 20px/28px Manrope",
      color: "#465869",
    },
    "& h3": {
      font: "700 24px/33px Manrope",
      color: "#465869",
    },
  },
  sendToReviewButton: {
    font: "700 14px/24px Inter",
    width: 156,
  },
  modalContent: {
    font: "400 16px/24px Inter",
    color: "#232325",
  },
}));

export default status;
